import Navbar from '../../components/navbar/navbar.jsx'
import api from '../../api.js'
import React, { useEffect, useState } from 'react'
import Sku from '../../components/sku/compsku.jsx'
import Globais from '../../services/globais.js'
import { Alert } from 'react-bootstrap'
import swal from 'sweetalert'

function Skus() {
  const [sku, setSku] = useState([])
  const [adicionatexto, setTexto] = useState('')

  const handleBuscar = (event) => {
    if (event.key === 'Enter') {
      setSku([])

      ListaSku(adicionatexto)
      event.preventDefault()
    }
  }

  function ListaSku() {
    api
      .get('https://mobile.belahome.com.br/ListaSku', {
        baseURL: 'mobile.belahome.com.br',

        params: {
          sku: adicionatexto,
          conta: localStorage.idconta,
        },
        auth: {
          username: 'admin',
          password: 'admin',
        },
      })

      .then((response) => {
        if (response.status == 200) {
          setSku(response.data)
        }
      })
  }

  useEffect(() => {}, [])

  return (
    <>
      <Navbar />

      <div className="container-fluid mt-page">
        <div className="ms-4 d-flex justify-content-between">
          <h2>Listagem Skus Filhos</h2>
          <button className="btn btn-primary me-4">Atualizar</button>
        </div>

        <div className="mt-5 ms-4 me-4">
          <div className="input-group input-group-sm mb-3">
            <span
              className="input-group-text input-tamanho"
              id="inputGroup-sizing-sm"
            >
              Informe Sku
            </span>
            <input
              type="text"
              className="form-control"
              id="InputBusca"
              onKeyDown={handleBuscar}
              onChange={(e) => setTexto(e.target.value)}
              value={adicionatexto}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div class="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Descricao</th>
                  <th scope="col">Liberado Venda</th>
                  <th scope="col">Sku</th>

                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {sku.map((sku) => {
                  return (
                    <Sku
                      key={sku.sku}
                      descricao={sku.descricao}
                      liberadovenda={sku.liberadovenda}
                      sku={sku.sku}
                      localizacao={sku.localizacao}
                    />
                  )
                })}
              </tbody>
            </table>

            {sku.length == 0 ? <div className="no-item">Nada aqui</div> : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default Skus
